module.exports = __webpack_public_path__ + "icomoon.78bd89f2449fafd32fab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon/icomoon.svg?1ofj2m
// module id = 342
// module chunks = 2